// AuthProvider — wraps the app, watches Firebase Auth state, exposes useAuth().
// Also re-fetches custom claims after sign-in so vendor_id and role are available.

import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase.js';

const AuthCtx = createContext({ user: null, claims: null, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [claims, setClaims] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (u) {
        // Force-refresh so claims set server-side just before this are visible.
        const tokenResult = await u.getIdTokenResult(true);
        setUser(u);
        setClaims(tokenResult.claims);
      } else {
        setUser(null);
        setClaims(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  return (
    <AuthCtx.Provider value={{ user, claims, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
